/** Stripe's brand slugs, spelled the way the networks do. Anything unlisted is title-cased. */
const BRAND_NAMES: Record<string, string> = {
  amex: 'American Express',
  cartes_bancaires: 'Cartes Bancaires',
  diners: 'Diners Club',
  discover: 'Discover',
  eftpos_au: 'Eftpos Australia',
  jcb: 'JCB',
  mastercard: 'Mastercard',
  unionpay: 'UnionPay',
  visa: 'Visa',
};

export function cardBrandName(brand: string): string {
  return (
    BRAND_NAMES[brand] ??
    brand
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  );
}
